export function heimdall() {
  if (import.meta.env.DEV) return 'http://localhost:3000/heimdall'
  return 'https://api.steerlab.ai/heimdall'
}
